var map = {
	"./adminprofile/edit": [
		2013,
		19
	],
	"./agentprofile/edit": [
		2014,
		22
	],
	"./ai_assistant/edit": [
		2015,
		25
	],
	"./api_key/edit": [
		2016,
		28
	],
	"./canned_answer/edit": [
		2017,
		33
	],
	"./chat_configuration/edit": [
		2018,
		6
	],
	"./client/edit": [
		2019,
		36
	],
	"./destination_restrictor/edit": [
		2020,
		38
	],
	"./disposition/edit": [
		2021,
		41
	],
	"./field/edit": [
		2022,
		44
	],
	"./form/edit": [
		2023,
		47
	],
	"./form_website/edit": [
		2024,
		50
	],
	"./gdpr/edit": [
		2025,
		52
	],
	"./invoice/edit": [
		2026,
		54
	],
	"./invoice_post/edit": [
		2027,
		57
	],
	"./journey/edit": [
		2028,
		60
	],
	"./journey_draft/edit": [
		2029,
		63
	],
	"./journey_variable/edit": [
		2030,
		67
	],
	"./list/edit": [
		2031,
		70
	],
	"./list_file/edit": [
		2032,
		73
	],
	"./mail_account/edit": [
		2033,
		76
	],
	"./operational_hours/edit": [
		2034,
		79
	],
	"./organization/edit": [
		2035,
		82
	],
	"./pause/edit": [
		2036,
		85
	],
	"./phonenumber_monthly_cost/edit": [
		2037,
		88
	],
	"./phonenumber_monthly_cost_parent/edit": [
		2038,
		91
	],
	"./phonenumber_purchase/edit": [
		2039,
		95
	],
	"./phonenumber_setup_cost/edit": [
		2040,
		98
	],
	"./phonenumber_setup_cost_parent/edit": [
		2041,
		101
	],
	"./points_system/edit": [
		2042,
		105
	],
	"./prepaid_credit/edit": [
		2043,
		108
	],
	"./queue/edit": [
		2044,
		111
	],
	"./signature/edit": [
		2045,
		115
	],
	"./skill/edit": [
		2046,
		118
	],
	"./sla_policy/edit": [
		2047,
		121
	],
	"./sound/edit": [
		2048,
		124
	],
	"./stats_alarm/edit": [
		2049,
		127
	],
	"./stats_custom_metric/edit": [
		2050,
		130
	],
	"./stats_report/edit": [
		2051,
		133
	],
	"./stats_widget/edit": [
		2052,
		136
	],
	"./superadmin_profile/edit": [
		2053,
		139
	],
	"./tag/edit": [
		2054,
		142
	],
	"./tariff/edit": [
		2055,
		145
	],
	"./tariff_parent/edit": [
		2056,
		148
	],
	"./team/edit": [
		2057,
		151
	],
	"./text_message_source/edit": [
		2058,
		9
	],
	"./time_interval/edit": [
		2059,
		155
	],
	"./user/edit": [
		2060,
		158
	],
	"./voice_asterisk/edit": [
		2061,
		161
	],
	"./voice_asterisk_downgrade/edit": [
		2062,
		164
	],
	"./voice_recording_transcript_setting/edit": [
		2063,
		168
	],
	"./voice_route/edit": [
		2064,
		171
	],
	"./voice_shortcut/edit": [
		2065,
		174
	],
	"./voice_trunk/edit": [
		2066,
		177
	],
	"./voice_voicemail/edit": [
		2067,
		180
	],
	"./wallboard/edit": [
		2068,
		183
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1883;
module.exports = webpackAsyncContext;